import React, { useEffect, useState } from "react";
import { Spinner } from "../../../Spinner/Spinner";
import {
  StyledButtonsWrapper,
  StyledDownloadButton,
  StyledStatus,
  StyledSpinnerContainer,
  StyledWrapper,
  StyledBondMessage,
} from "./BondFinal.styled";
import { downloadPDF } from "../../../../helpers/utils";
import Notification from "../../../notification/Notification";
import { BondRecordData } from "../../FormBondApp.types";

interface BondFinalProps {
  pdfUrl: string;
  isLoading: boolean;
  isError: boolean;
  bondStatus: string;
  bondRecord?: BondRecordData;
}

export const BondFinal: React.FC<BondFinalProps> = ({
  isLoading,
  pdfUrl,
  bondStatus,
  bondRecord,
}) => {
  const [bondFilename, setBondFileName] = useState("");

  useEffect(() => {
    const filename = `${
      bondRecord?.product?.name || bondRecord?.product_name || "bond"
    }`;
    const changedFileName = filename.replaceAll(" ", "_").toLowerCase();
    setBondFileName(changedFileName);
  }, [bondRecord]);

  return (
    <StyledWrapper>
      {isLoading ? (
        <StyledSpinnerContainer>
          <Spinner />
          <span>Loading...</span>
        </StyledSpinnerContainer>
      ) : (
        <>
          {bondStatus === "BOND_ISSUED" ? (
            <>
              <StyledButtonsWrapper>
                <StyledDownloadButton
                  // href={pdfUrl}
                  disabled={!pdfUrl}
                  // rel="noopener noreferrer"
                  // download
                  onClick={() => downloadPDF(pdfUrl, bondFilename)}
                >
                  Download My Bond
                </StyledDownloadButton>
              </StyledButtonsWrapper>
              {pdfUrl && (
                <object
                  width={"100%"}
                  style={{ height: 500 }}
                  data={pdfUrl}
                  type="application/pdf"
                />
              )}
            </>
          ) : (
            <Notification status={bondStatus} isShowLink={true} />
          )}
        </>
      )}
    </StyledWrapper>
  );
};
